import { DefaultTemplate, COR, CORES_SIM_NAO } from './types';

// ============================================================
// COMERCIAL / VENDAS — Pipeline, Propostas, Pós-venda & Renovação
// ============================================================

const pipelineVendas: DefaultTemplate = {
  id: 'tpl_pipeline_vendas',
  name: 'Pipeline de Vendas',
  descricao: 'Funil completo de vendas: lead, qualificação, diagnóstico, proposta, negociação e fechamento. Com motivo de perda estruturado e SLA por etapa para você saber onde o funil vaza.',
  categoria: 'comercial',
  icone: '📈',
  etiquetas: [
    { nome: 'Grande conta', cor: COR.roxo },
    { nome: 'Indicação', cor: COR.verde },
    { nome: 'Reativação', cor: COR.azul },
    { nome: 'Esfriando', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'pv_e1', nome: 'Lead',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['pv_c1', 'pv_c5', 'pv_c6'],
      permiteMoverPara: ['pv_e2', 'pv_e7'],
      campos: [
        { id: 'pv_c1', nome: 'Empresa / Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pv_c2', nome: 'Contato', tipo: 'texto', obrigatorio: true },
        { id: 'pv_c3', nome: 'Telefone', tipo: 'telefone', obrigatorio: false },
        { id: 'pv_c4', nome: 'E-mail', tipo: 'texto', obrigatorio: false },
        { id: 'pv_c5', nome: 'Origem do Lead', tipo: 'lista', obrigatorio: true, opcoes: ['Site', 'Indicação', 'Prospecção ativa', 'Evento / Feira', 'Redes sociais', 'Anúncio pago', 'Cliente antigo'], coresOpcoes: { 'Indicação': COR.verde, 'Prospecção ativa': COR.azul, 'Cliente antigo': COR.ciano } },
        { id: 'pv_c6', nome: 'Segmento', tipo: 'lista', obrigatorio: false, opcoes: ['Indústria', 'Comércio', 'Serviços', 'Governo', 'Terceiro setor'] },
        { id: 'pv_c7', nome: 'Interesse Declarado', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pv_c8', nome: 'Vendedor', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'pv_e2', nome: 'Qualificação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pv_c1', 'pv_c12', 'pv_c13'],
      permiteMoverPara: ['pv_e3', 'pv_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c9', nome: 'Tem orçamento?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não', 'A definir'], coresOpcoes: { 'Sim': COR.verde, 'Não': COR.vermelho, 'A definir': COR.amarelo } },
        { id: 'pv_c10', nome: 'Falando com o decisor?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pv_c11', nome: 'Prazo de Decisão', tipo: 'lista', obrigatorio: false, opcoes: ['Imediato', 'Até 30 dias', '1 a 3 meses', 'Acima de 3 meses', 'Sem prazo'] },
        { id: 'pv_c12', nome: 'Valor Potencial', tipo: 'valor', obrigatorio: false },
        { id: 'pv_c13', nome: 'Lead qualificado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pv_c14', nome: 'Notas da Qualificação', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pv_e3', nome: 'Diagnóstico / Reunião',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['pv_c1', 'pv_c12', 'pv_c15'],
      permiteMoverPara: ['pv_e4', 'pv_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c15', nome: 'Data da Reunião', tipo: 'data', obrigatorio: false },
        { id: 'pv_c16', nome: 'Dor / Necessidade Identificada', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pv_c17', nome: 'Solução Proposta', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pv_c18', nome: 'Concorrentes na Disputa', tipo: 'texto', obrigatorio: false },
        { id: 'pv_c19', nome: 'Ata / Anotações', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pv_e4', nome: 'Proposta Enviada',
      tempoMaximoHoras: 72,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['pv_c1', 'pv_c20', 'pv_c22'],
      permiteMoverPara: ['pv_e5', 'pv_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c20', nome: 'Valor da Proposta', tipo: 'valor', obrigatorio: true },
        { id: 'pv_c21', nome: 'Proposta', tipo: 'anexo', obrigatorio: false },
        { id: 'pv_c22', nome: 'Validade da Proposta', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'pv_c23', nome: 'Condição de Pagamento', tipo: 'lista', obrigatorio: false, opcoes: ['À vista', '30 dias', '30/60', '30/60/90', 'Mensal recorrente'] },
        { id: 'pv_c24', nome: 'Follow-up realizado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pv_e5', nome: 'Negociação',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['pv_c1', 'pv_c25', 'pv_c27'],
      permiteMoverPara: ['pv_e6', 'pv_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c25', nome: 'Valor Negociado', tipo: 'valor', obrigatorio: false },
        { id: 'pv_c26', nome: 'Desconto Concedido (%)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 100 },
        { id: 'pv_c27', nome: 'Objeções do Cliente', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pv_c28', nome: 'Precisa aprovação de desconto?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pv_c29', nome: 'Fechou?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pv_e6', nome: 'Ganho',
      camposVisiveisNoCard: ['pv_c1', 'pv_c25', 'pv_c31'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c30', nome: 'Data do Fechamento', tipo: 'data', obrigatorio: true },
        { id: 'pv_c31', nome: 'Contrato / Pedido Assinado', tipo: 'anexo', obrigatorio: false },
        { id: 'pv_c32', nome: 'Faturamento aberto?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pv_c33', nome: 'Onboarding do cliente agendado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pv_e7', nome: 'Perdido',
      camposVisiveisNoCard: ['pv_c1', 'pv_c34'],
      permiteMoverPara: ['pv_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'pv_c34', nome: 'Motivo da Perda', tipo: 'lista', obrigatorio: true, opcoes: ['Preço', 'Perdeu para concorrente', 'Sem orçamento', 'Sem urgência', 'Não era o perfil', 'Sem resposta', 'Projeto cancelado'], coresOpcoes: { 'Preço': COR.amarelo, 'Perdeu para concorrente': COR.vermelho, 'Sem resposta': COR.cinza } },
        { id: 'pv_c35', nome: 'Detalhes', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pv_c36', nome: 'Reabordar em', tipo: 'data', obrigatorio: false },
        { id: 'pv_c37', nome: 'Vale reabordagem?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Lead qualificado segue para diagnóstico',
      etapaOrigemId: 'pv_e2',
      condicao: { campoId: 'pv_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pv_e3',
      etapaDestinoSenaoId: 'pv_e7',
    },
    {
      tipo: 'mover',
      nome: 'Fechou vira Ganho, não fechou vira Perdido',
      etapaOrigemId: 'pv_e5',
      condicao: { campoId: 'pv_c29', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pv_e6',
      etapaDestinoSenaoId: 'pv_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar data de reabordagem quando valer a pena',
      etapaOrigemId: 'pv_e7',
      condicao: { campoId: 'pv_c37', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['pv_c36'],
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar desconto quando precisar de aprovação',
      etapaOrigemId: 'pv_e5',
      condicao: { campoId: 'pv_c28', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['pv_c26'],
    },
  ],
  cards: [
    { id: 'pv_card1', titulo: 'Indústria Metalpar', etapaId: 'pv_e5', etiquetas: ['Grande conta'], valores: { pv_c1: 'Indústria Metalpar', pv_c2: 'Roberto Alencar', pv_c5: 'Prospecção ativa', pv_c6: 'Indústria', pv_c12: 180000, pv_c20: 180000, pv_c25: 165000 } },
    { id: 'pv_card2', titulo: 'Comércio Silva ME', etapaId: 'pv_e4', valores: { pv_c1: 'Comércio Silva ME', pv_c2: 'Silvana Silva', pv_c5: 'Site', pv_c6: 'Comércio', pv_c12: 24000, pv_c20: 24000 } },
    { id: 'pv_card3', titulo: 'Grupo Andrade', etapaId: 'pv_e6', etiquetas: ['Indicação'], valores: { pv_c1: 'Grupo Andrade', pv_c2: 'Marcelo Andrade', pv_c5: 'Indicação', pv_c6: 'Serviços', pv_c20: 15000, pv_c25: 15000 } },
    { id: 'pv_card4', titulo: 'Rede Farmácia Vida', etapaId: 'pv_e3', valores: { pv_c1: 'Rede Farmácia Vida', pv_c2: 'Cristina Melo', pv_c5: 'Evento / Feira', pv_c6: 'Comércio', pv_c12: 45000 } },
    { id: 'pv_card5', titulo: 'Transportes Rocha', etapaId: 'pv_e2', valores: { pv_c1: 'Transportes Rocha', pv_c2: 'Jonas Rocha', pv_c5: 'Redes sociais', pv_c6: 'Serviços', pv_c9: 'A definir' } },
    { id: 'pv_card6', titulo: 'Construtora Horizonte', etapaId: 'pv_e7', etiquetas: ['Esfriando'], valores: { pv_c1: 'Construtora Horizonte', pv_c2: 'Ana Prado', pv_c5: 'Anúncio pago', pv_c34: 'Preço', pv_c37: 'Sim' } },
    { id: 'pv_card7', titulo: 'Distribuidora Norte', etapaId: 'pv_e1', etiquetas: ['Reativação'], valores: { pv_c1: 'Distribuidora Norte', pv_c2: 'Paulo Nunes', pv_c5: 'Cliente antigo', pv_c6: 'Comércio' } },
  ],
  tour: [
    '📈 Funil de vendas com etapa, prazo e motivo de perda estruturado.',
    '1️⃣ "Lead": entrada com origem — descubra qual canal realmente vende.',
    '2️⃣ "Qualificação": orçamento, decisor e prazo. Não qualificou? vai para Perdido com motivo.',
    '3️⃣ "Diagnóstico": a dor do cliente registrada — é o que sustenta a proposta.',
    '4️⃣ "Proposta Enviada": ordenada por validade, para você cobrar antes de vencer.',
    '5️⃣ "Negociação": objeções e desconto. Marcou "Fechou = Sim"? vira Ganho automaticamente.',
    '❌ "Perdido" com motivo padronizado — relatório de perda por causa, sem digitação livre.',
    '🔁 Vale reabordar? o campo de data aparece e o card pode voltar para o Lead.',
  ],
  etapasDicas: [
    { quemFaz: 'Vendedor / SDR', objetivo: 'Capturar o lead com origem correta — é o que mede o ROI de marketing.', conexoes: ['Receba leads do site direto neste fluxo via Portal Público'], ondeConfigurar: 'Portais > Formulário público' },
    { quemFaz: 'SDR / Pré-vendas', objetivo: 'Não gastar hora de vendedor com quem não tem orçamento nem decisor.', automacoes: ['Já configurado: não qualificado vai para Perdido'], ondeConfigurar: 'Automações > "Lead qualificado segue para diagnóstico"' },
    { quemFaz: 'Vendedor', objetivo: 'Entender a dor antes de propor preço — proposta sem diagnóstico vira leilão.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Vendedor', objetivo: 'Enviar e acompanhar a proposta dentro da validade.', conexoes: ['Ligue ao fluxo de Propostas Comerciais para elaboração com aprovação de margem'], ondeConfigurar: 'Conexões entre Fluxos > Propostas Comerciais' },
    { quemFaz: 'Vendedor + Gerente', objetivo: 'Registrar objeções e controlar desconto com alçada.', automacoes: ['Já configurado: fechou vira Ganho, não fechou vira Perdido', 'Já configurado: campo de desconto aparece quando precisa aprovação'], ondeConfigurar: 'Automações > "Fechou vira Ganho, não fechou vira Perdido"' },
    { quemFaz: 'Vendedor + Financeiro', objetivo: 'Transformar a venda em contrato e faturamento sem perder tempo.', conexoes: ['Ligue a Contas a Receber: negócio Ganho cria o faturamento automaticamente', 'Ligue a Pós-venda para agendar a implantação'], ondeConfigurar: 'Conexões entre Fluxos > Contas a Receber' },
    { quemFaz: 'Vendedor', objetivo: 'Registrar por que perdeu — é o relatório mais valioso do comercial.', automacoes: ['Já configurado: data de reabordagem aparece quando vale a pena voltar'], ondeConfigurar: 'Automações > "Mostrar data de reabordagem quando valer a pena"' },
  ],
};

const propostas: DefaultTemplate = {
  id: 'tpl_propostas',
  name: 'Propostas Comerciais',
  descricao: 'Elaboração técnica e comercial da proposta com cálculo de margem, aprovação de desconto por alçada, envio e acompanhamento até o aceite. Para quem vende projeto, não produto de prateleira.',
  categoria: 'comercial',
  icone: '📄',
  etiquetas: [
    { nome: 'Margem baixa', cor: COR.vermelho },
    { nome: 'Licitação', cor: COR.roxo },
    { nome: 'Renovação', cor: COR.azul },
  ],
  etapas: [
    {
      id: 'pr_e1', nome: 'Solicitação de Proposta',
      tempoMaximoHoras: 8,
      camposVisiveisNoCard: ['pr_c1', 'pr_c3', 'pr_c5'],
      permiteMoverPara: ['pr_e2'],
      campos: [
        { id: 'pr_c1', nome: 'Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pr_c2', nome: 'Vendedor Responsável', tipo: 'texto', obrigatorio: true },
        { id: 'pr_c3', nome: 'Objeto da Proposta', tipo: 'texto', obrigatorio: true },
        { id: 'pr_c4', nome: 'Escopo Solicitado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pr_c5', nome: 'Prazo para Entregar a Proposta', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'pr_c6', nome: 'Tipo', tipo: 'lista', obrigatorio: false, opcoes: ['Novo cliente', 'Renovação', 'Ampliação', 'Licitação'], coresOpcoes: { 'Licitação': COR.roxo, 'Renovação': COR.azul } },
        { id: 'pr_c7', nome: 'Documentos do Cliente', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pr_e2', nome: 'Elaboração Técnica',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pr_c1', 'pr_c3'],
      permiteMoverPara: ['pr_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c8', nome: 'Responsável Técnico', tipo: 'texto', obrigatorio: false },
        { id: 'pr_c9', nome: 'Escopo Detalhado', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pr_c10', nome: 'Prazo de Execução', tipo: 'texto', obrigatorio: false },
        { id: 'pr_c11', nome: 'Recursos Necessários', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pr_c12', nome: 'Riscos Identificados', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pr_e3', nome: 'Precificação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['pr_c1', 'pr_c14', 'pr_c16'],
      permiteMoverPara: ['pr_e4', 'pr_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c13', nome: 'Custo Estimado', tipo: 'valor', obrigatorio: true },
        { id: 'pr_c14', nome: 'Valor de Venda', tipo: 'valor', obrigatorio: true },
        { id: 'pr_c15', nome: 'Margem (%)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 100 },
        { id: 'pr_c16', nome: 'Margem abaixo do mínimo?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pr_c17', nome: 'Condição de Pagamento', tipo: 'lista', obrigatorio: false, opcoes: ['À vista', '30 dias', '30/60', '30/60/90', 'Mensal recorrente'] },
      ],
    },
    {
      id: 'pr_e4', nome: 'Aprovação de Margem',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['pr_c1', 'pr_c14', 'pr_c18'],
      permiteMoverPara: ['pr_e5', 'pr_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c18', nome: 'Aprovado pela Diretoria?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pr_c19', nome: 'Valor Mínimo Autorizado', tipo: 'valor', obrigatorio: false },
        { id: 'pr_c20', nome: 'Justificativa Estratégica', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'pr_e5', nome: 'Proposta Enviada',
      tempoMaximoHoras: 120,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['pr_c1', 'pr_c14', 'pr_c23'],
      permiteMoverPara: ['pr_e6', 'pr_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c21', nome: 'PDF da Proposta', tipo: 'anexo', obrigatorio: false },
        { id: 'pr_c22', nome: 'Data do Envio', tipo: 'data', obrigatorio: true },
        { id: 'pr_c23', nome: 'Validade', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'pr_c24', nome: 'Follow-ups Realizados', tipo: 'numero', obrigatorio: false },
        { id: 'pr_c25', nome: 'Resposta do Cliente', tipo: 'lista', obrigatorio: false, opcoes: ['Aceita', 'Recusada', 'Pediu revisão', 'Sem resposta'], coresOpcoes: { 'Aceita': COR.verde, 'Recusada': COR.vermelho, 'Pediu revisão': COR.amarelo } },
      ],
    },
    {
      id: 'pr_e6', nome: 'Aceita',
      camposVisiveisNoCard: ['pr_c1', 'pr_c14'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c26', nome: 'Data do Aceite', tipo: 'data', obrigatorio: false },
        { id: 'pr_c27', nome: 'Aceite Formal', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pr_e7', nome: 'Recusada',
      camposVisiveisNoCard: ['pr_c1', 'pr_c28'],
      permiteMoverPara: ['pr_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'pr_c28', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Preço', 'Prazo', 'Escopo', 'Concorrente', 'Projeto cancelado', 'Sem resposta'] },
        { id: 'pr_c29', nome: 'Detalhes / Aprendizado', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Margem baixa exige aprovação da diretoria',
      etapaOrigemId: 'pr_e3',
      condicao: { campoId: 'pr_c16', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pr_e4',
      etapaDestinoSenaoId: 'pr_e5',
    },
    {
      tipo: 'mover',
      nome: 'Diretoria aprovou libera o envio',
      etapaOrigemId: 'pr_e4',
      condicao: { campoId: 'pr_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pr_e5',
      etapaDestinoSenaoId: 'pr_e3',
    },
    {
      tipo: 'mover',
      nome: 'Cliente aceitou a proposta',
      etapaOrigemId: 'pr_e5',
      condicao: { campoId: 'pr_c25', operador: 'igual', valor: 'Aceita' },
      etapaDestinoId: 'pr_e6',
    },
  ],
  cards: [
    { id: 'pr_card1', titulo: 'Indústria Metalpar', etapaId: 'pr_e4', etiquetas: ['Margem baixa'], valores: { pr_c1: 'Indústria Metalpar', pr_c3: 'Projeto de automação da linha 3', pr_c13: 140000, pr_c14: 165000, pr_c15: 15, pr_c16: 'Sim' } },
    { id: 'pr_card2', titulo: 'Rede Farmácia Vida', etapaId: 'pr_e5', valores: { pr_c1: 'Rede Farmácia Vida', pr_c3: 'Implantação em 12 lojas', pr_c14: 45000, pr_c15: 34 } },
    { id: 'pr_card3', titulo: 'Prefeitura Municipal', etapaId: 'pr_e2', etiquetas: ['Licitação'], valores: { pr_c1: 'Prefeitura Municipal', pr_c3: 'Pregão 042/2026', pr_c6: 'Licitação' } },
    { id: 'pr_card4', titulo: 'Tech Solutions Ltda', etapaId: 'pr_e6', etiquetas: ['Renovação'], valores: { pr_c1: 'Tech Solutions Ltda', pr_c3: 'Renovação do contrato de suporte', pr_c6: 'Renovação', pr_c14: 102000 } },
    { id: 'pr_card5', titulo: 'Construtora Horizonte', etapaId: 'pr_e7', valores: { pr_c1: 'Construtora Horizonte', pr_c3: 'Sistema de gestão de obras', pr_c14: 88000, pr_c28: 'Preço', pr_c29: 'Concorrente entrou 22% abaixo com escopo reduzido.' } },
    { id: 'pr_card6', titulo: 'Transportes Rocha', etapaId: 'pr_e1', valores: { pr_c1: 'Transportes Rocha', pr_c3: 'Roteirização de frota' } },
  ],
  tour: [
    '📄 Proposta com margem controlada e alçada automática.',
    '1️⃣ "Solicitação": o vendedor pede a proposta com escopo e prazo de entrega.',
    '2️⃣ "Elaboração Técnica": escopo detalhado, prazo e riscos.',
    '3️⃣ "Precificação": custo, valor e margem. Margem abaixo do mínimo? sobe para a diretoria sozinho.',
    '4️⃣ "Aprovação de Margem": reprovou volta para precificação — nada sai fora da política.',
    '5️⃣ "Proposta Enviada": ordenada por validade, com contador de follow-ups.',
    '✅ Cliente respondeu "Aceita"? o card vira "Aceita" automaticamente.',
    '📉 Recusada tem motivo padronizado — vira aprendizado, não desabafo.',
  ],
};

const posVenda: DefaultTemplate = {
  id: 'tpl_pos_venda',
  name: 'Pós-venda & Renovação',
  descricao: 'Sucesso do cliente do onboarding à renovação: implantação, acompanhamento, pesquisa de satisfação, risco de churn e renovação de contrato. Segurar cliente custa menos que conquistar.',
  categoria: 'comercial',
  icone: '🤝',
  etiquetas: [
    { nome: 'Risco de churn', cor: COR.vermelho },
    { nome: 'Promotor', cor: COR.verde },
    { nome: 'Upsell', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'pz_e1', nome: 'Onboarding do Cliente',
      tempoMaximoHoras: 168,
      camposVisiveisNoCard: ['pz_c1', 'pz_c4'],
      permiteMoverPara: ['pz_e2'],
      campos: [
        { id: 'pz_c1', nome: 'Cliente', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'pz_c2', nome: 'Contato Principal', tipo: 'texto', obrigatorio: false },
        { id: 'pz_c3', nome: 'Telefone', tipo: 'telefone', obrigatorio: false },
        { id: 'pz_c4', nome: 'Etapas da Implantação', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Reunião de kickoff', 'Configuração inicial', 'Treinamento da equipe', 'Migração de dados', 'Go-live', 'Acompanhamento 30 dias'] },
        { id: 'pz_c5', nome: 'Data de Início', tipo: 'data', obrigatorio: false },
        { id: 'pz_c6', nome: 'Responsável (CS)', tipo: 'texto', obrigatorio: false },
        { id: 'pz_c7', nome: 'Implantação concluída?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pz_e2', nome: 'Cliente Ativo',
      camposVisiveisNoCard: ['pz_c1', 'pz_c9', 'pz_c11'],
      permiteMoverPara: ['pz_e3', 'pz_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'pz_c8', nome: 'Valor Mensal', tipo: 'valor', obrigatorio: false },
        { id: 'pz_c9', nome: 'Saúde da Conta', tipo: 'lista', obrigatorio: true, opcoes: ['Saudável', 'Atenção', 'Crítica'], coresOpcoes: { 'Saudável': COR.verde, 'Atenção': COR.amarelo, 'Crítica': COR.vermelho } },
        { id: 'pz_c10', nome: 'Última Interação', tipo: 'data', obrigatorio: false },
        { id: 'pz_c11', nome: 'NPS (0-10)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 10 },
        { id: 'pz_c12', nome: 'Fim do Contrato', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'pz_c13', nome: 'Oportunidade de upsell?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pz_e3', nome: 'Risco de Churn',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['pz_c1', 'pz_c14'],
      permiteMoverPara: ['pz_e2', 'pz_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'pz_c14', nome: 'Sinal de Risco', tipo: 'lista', obrigatorio: true, opcoes: ['Queda de uso', 'Reclamações recorrentes', 'Troca de gestor no cliente', 'Atraso de pagamento', 'Pediu proposta de saída', 'Corte de orçamento'], coresOpcoes: { 'Pediu proposta de saída': COR.vermelho, 'Queda de uso': COR.amarelo } },
        { id: 'pz_c15', nome: 'Plano de Ação', tipo: 'texto_longo', obrigatorio: true },
        { id: 'pz_c16', nome: 'Reunião de resgate feita?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'pz_c17', nome: 'Risco revertido?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pz_e4', nome: 'Renovação em Negociação',
      tempoMaximoHoras: 240,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['pz_c1', 'pz_c12', 'pz_c19'],
      permiteMoverPara: ['pz_e5', 'pz_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'pz_c18', nome: 'Proposta de Renovação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pz_c19', nome: 'Novo Valor Mensal', tipo: 'valor', obrigatorio: false },
        { id: 'pz_c20', nome: 'Reajuste (%)', tipo: 'numero', obrigatorio: false },
        { id: 'pz_c21', nome: 'Renovou?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'pz_e5', nome: 'Renovado',
      camposVisiveisNoCard: ['pz_c1', 'pz_c19'],
      permiteMoverPara: ['pz_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'pz_c22', nome: 'Nova Vigência', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'pz_c23', nome: 'Contrato Renovado', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'pz_e6', nome: 'Cliente Perdido',
      camposVisiveisNoCard: ['pz_c1', 'pz_c24'],
      permiteCriarCards: false,
      campos: [
        { id: 'pz_c24', nome: 'Motivo do Churn', tipo: 'lista', obrigatorio: true, opcoes: ['Preço', 'Insatisfação com o produto', 'Insatisfação com o atendimento', 'Foi para concorrente', 'Fechou / reduziu operação', 'Corte de custos'] },
        { id: 'pz_c25', nome: 'Aprendizado', tipo: 'texto_longo', obrigatorio: false },
        { id: 'pz_c26', nome: 'Vale tentar reconquista?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Implantação concluída ativa o cliente',
      etapaOrigemId: 'pz_e1',
      condicao: { campoId: 'pz_c7', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pz_e2',
    },
    {
      tipo: 'mover',
      nome: 'Conta crítica entra em risco de churn',
      etapaOrigemId: 'pz_e2',
      condicao: { campoId: 'pz_c9', operador: 'igual', valor: 'Crítica' },
      etapaDestinoId: 'pz_e3',
    },
    {
      tipo: 'mover',
      nome: 'Risco revertido devolve o cliente para ativo',
      etapaOrigemId: 'pz_e3',
      condicao: { campoId: 'pz_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pz_e2',
      etapaDestinoSenaoId: 'pz_e6',
    },
    {
      tipo: 'mover',
      nome: 'Renovou continua, não renovou vira churn',
      etapaOrigemId: 'pz_e4',
      condicao: { campoId: 'pz_c21', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'pz_e5',
      etapaDestinoSenaoId: 'pz_e6',
    },
  ],
  cards: [
    { id: 'pz_card1', titulo: 'Tech Solutions Ltda', etapaId: 'pz_e2', etiquetas: ['Promotor', 'Upsell'], valores: { pz_c1: 'Tech Solutions Ltda', pz_c8: 8500, pz_c9: 'Saudável', pz_c11: 9, pz_c13: 'Sim' } },
    { id: 'pz_card2', titulo: 'Distribuidora Norte', etapaId: 'pz_e3', etiquetas: ['Risco de churn'], valores: { pz_c1: 'Distribuidora Norte', pz_c8: 4200, pz_c9: 'Crítica', pz_c11: 4, pz_c14: 'Reclamações recorrentes', pz_c15: 'Reunião com diretoria + plano de correção em 15 dias.' } },
    { id: 'pz_card3', titulo: 'Grupo Andrade', etapaId: 'pz_e4', valores: { pz_c1: 'Grupo Andrade', pz_c8: 12000, pz_c9: 'Saudável', pz_c11: 8, pz_c19: 12800 } },
    { id: 'pz_card4', titulo: 'Comércio Silva ME', etapaId: 'pz_e1', valores: { pz_c1: 'Comércio Silva ME', pz_c6: 'Marina Costa' } },
    { id: 'pz_card5', titulo: 'Rede Farmácia Vida', etapaId: 'pz_e5', valores: { pz_c1: 'Rede Farmácia Vida', pz_c8: 6400, pz_c19: 6900 } },
    { id: 'pz_card6', titulo: 'Construtora Horizonte', etapaId: 'pz_e6', valores: { pz_c1: 'Construtora Horizonte', pz_c24: 'Corte de custos', pz_c26: 'Sim' } },
  ],
  tour: [
    '🤝 Cliente conquistado é só o começo — aqui você garante que ele fica.',
    '1️⃣ "Onboarding": checklist de implantação até o go-live.',
    '2️⃣ "Cliente Ativo": saúde da conta, NPS e data de fim de contrato.',
    '3️⃣ Marcou a saúde como "Crítica"? o card vai sozinho para "Risco de Churn".',
    '4️⃣ "Risco de Churn": sinal identificado + plano de ação obrigatório.',
    '5️⃣ "Renovação": coluna ordenada por vencimento de contrato.',
    '📉 "Cliente Perdido" com motivo padronizado — o relatório de churn se monta sozinho.',
  ],
};

export const TEMPLATES_COMERCIAL: DefaultTemplate[] = [
  pipelineVendas,
  propostas,
  posVenda,
];
